import { useState } from "react";
import { GALLERY } from "../lib/exhibitionData";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative pl-section-dark"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-4 md:mb-4">
          <div>
            <span className="overline">The Gallery</span>
            <h2 className="mt-4 font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#F5F0E8]">
              Seventy frames, <br />
              <span className="italic">one long street.</span>
            </h2>
          </div>
          <p className="max-w-md text-base md:text-lg pl-mute leading-relaxed">
            A walk through selected prints from the exhibition. Tap any frame
            for its title and place.
          </p>
        </div>

        {/* CTA placed directly above the grid — exactly 24px to first row */}
        <a
          href="#gallery"
          data-testid="gallery-see-work-btn"
          className="pl-cta"
          style={{
            marginBottom: "24px",
            background: "#F5F0E8",
            color: "#0A0A0A",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#C41E1E";
            e.currentTarget.style.color = "#F5F0E8";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#F5F0E8";
            e.currentTarget.style.color = "#0A0A0A";
          }}
        >
          See the Work
          <span aria-hidden>→</span>
        </a>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 auto-rows-[320px] md:auto-rows-[360px] lg:auto-rows-[380px] gap-6">
          {GALLERY.map((img, idx) => (
            <button
              key={idx}
              onClick={() => setActive(img)}
              data-testid={`gallery-item-${idx}`}
              className="gallery-item focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C41E1E] mb-2"
              aria-label={`View ${img.title}`}
            >
              <img src={img.src} alt={img.title} loading="lazy" />
              <div className="caption">
                <div className="font-serif-display italic text-lg md:text-xl">
                  {img.title}
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] mt-1 opacity-80">
                  {img.location}
                </div>
              </div>
            </button>
          ))}
        </div>

        <p className="mt-10 text-sm pl-mute max-w-2xl">
          The full edition of seventy-two prints will be on view from April 2,
          2027. Photographs © Abdou Karim Ndoye. Reproduction by permission
          only.
        </p>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[100] bg-[#0A0A0A]/95 flex items-center justify-center p-6 md:p-12"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 text-[#F5F0E8] text-[11px] uppercase tracking-[0.3em] hover:text-[#C41E1E]"
            data-testid="gallery-lightbox-close"
          >
            Close ×
          </button>
          <figure
            onClick={(e) => e.stopPropagation()}
            className="max-w-5xl w-full"
          >
            <img
              src={active.src}
              alt={active.title}
              className="w-full max-h-[80vh] object-contain"
            />
            <figcaption className="mt-5 flex flex-col md:flex-row md:items-end md:justify-between gap-2">
              <span className="font-serif-display italic text-2xl md:text-3xl text-[#F5F0E8]">
                {active.title}
              </span>
              <span className="text-[11px] uppercase tracking-[0.3em] pl-mute">
                {active.location}
              </span>
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}
